const Errorcomponent = ({ error }) => {

    return (
        <div className="error-box">
            <section className="error-header">
                <h3>Error!!</h3>
            </section>
            <section className="error-body">
                <p className="error-msg">{error}</p>
            </section>
        </div>
    )
}

export default Errorcomponent